var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"login-btn line",on:{"click":function($event){$event.preventDefault();return _vm.login($event)}}},[_vm._v(" 使用LINE版本 ")])}
var staticRenderFns = []

export { render, staticRenderFns }